// use a different color to mark content based on its origin
import {
  CmsHardwareContentType,
  CmsHardwareDescriptionType,
  GetHardwareResponseType,
  HardwareOptionType,
} from '@/types/fitting-hardware';

const colorForCmsContentUrl = (url: string) => {
  if (url.includes('/api')) {
    return '209, 2, 27';
  }
  if (url.includes('/snippet')) {
    return '255, 204, 0';
  }
  return '74, 144, 226';
};

export function wrapContentFromString(cmsContent: string, cmsUrl: string) {
  const color = colorForCmsContentUrl(cmsUrl);

  return `${'<div style="'
        + 'border: 2px solid rgba('}${color}, 1); `
        + `background-color: rgba(${color}, 0.3);" `
        + `title="CMS Pfad = '${cmsUrl}'">${
          cmsContent
        }</div>`;
}

export function renderCmsContent(cmsTariffContent: CmsHardwareContentType): string {
  if (cmsTariffContent.debugInfo) {
    return wrapContentFromString(cmsTariffContent.content, cmsTariffContent.debugInfo.url);
  }
  return cmsTariffContent.content;
}

function renderedCmsContent(cmsHardwareContent: CmsHardwareContentType): CmsHardwareContentType {
  return {
    ...cmsHardwareContent,
    rendered: renderCmsContent(cmsHardwareContent),
  };
}

function renderedCmsDescription(cmsHardwareDescriptionType: CmsHardwareDescriptionType)
  : CmsHardwareDescriptionType {
  return {
    name: renderedCmsContent(cmsHardwareDescriptionType.name),
    description: renderedCmsContent(cmsHardwareDescriptionType.description),
    imageUrl: renderedCmsContent(cmsHardwareDescriptionType.imageUrl),
    hint: cmsHardwareDescriptionType.hint
      ? renderedCmsContent(cmsHardwareDescriptionType.hint)
      : undefined,
    detailDescription: cmsHardwareDescriptionType.detailDescription
        ? renderedCmsContent(cmsHardwareDescriptionType.detailDescription)
        :undefined
  };
}

function renderedHardwareOptions(hardwareOptions: HardwareOptionType[])
  : HardwareOptionType[] {
  return hardwareOptions.map((hardwareOption) => ({
    ...hardwareOption,
    cmsContent: renderedCmsDescription(hardwareOption.cmsContent),
  }));
}

export function withRenderedCmsContent(getHardwareResponse: GetHardwareResponseType)
  : GetHardwareResponseType {
  return {
    ...getHardwareResponse,
    hardware: renderedHardwareOptions(getHardwareResponse.hardware),
    hardwareSelectionHint: renderedCmsContent(getHardwareResponse.hardwareSelectionHint),
    hardwareSelectionEnabled: getHardwareResponse.hardwareSelectionEnabled,
    accessType: getHardwareResponse.accessType

  };
}
